import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'

const ProductItemCreateModalUI = ({ context, messageList, successMsg, errorList, setErrorList,
  // modes
  createMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // maker
  maker, onMakerChange, makerError, setMakerError,
  // item name
  name, onItemNameChange, nameError, setNameError,
  // category
  category, onCategoryChange, categoryError, setCategoryError,
  // mrp
  mrp, onPriceChange, mrpError, setMrpError,
}) =>
  <ModalFormUI
    context={context}
    messageList={messageList}
    titleMessageKey='c_create_product_item'
    buttonMessageKey='c_create'
    cancelMessageKey='c_cancel'
    isOpen={createMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF name='maker' required={true} maxLength={40}
      messageList={messageList} labelKey='c_maker_name'
      value={maker} onChange={onMakerChange}
      error={makerError} setError={setMakerError}
      autoFocus={true}
    />
    <InputTextSF name='name' required={true} maxLength={40}
      messageList={messageList} labelKey='c_item_name'
      value={name} onChange={onItemNameChange}
      error={nameError} setError={setNameError}
      autoFocus={true}
    />
    <InputTextSF name='category' required={true} maxLength={40}
      messageList={messageList} labelKey='c_category'
      value={category} onChange={onCategoryChange}
      error={categoryError} setError={setCategoryError}
      autoFocus={true}
    />
    <InputTextSF type='mrp' name='mrp' required={true} maxLength={13}
      messageList={messageList} labelKey='c_price'
      value={mrp} onChange={onPriceChange}
      error={mrpError} setError={setMrpError}
      autoFocus={true}
    />
  </ModalFormUI>

export default ProductItemCreateModalUI
